module.exports = __webpack_public_path__ + "static/media/share-alt.7f2049c3.svg";